// 合同签约状态
// prettier-ignore
export const SignStatusList = [
    { label: '待签约', value: 15 },
    { label: '签约超时', value: 16 },
    { label: '待美团签约', value: 19 },
    { label: '签约成功', value: 23 },
    { label: '已归档', value: 25 },
    { label: '已失效', value: 27 },
    { label: '已作废', value: 30 }
];

export const SignStatusMap = SignStatusList.reduce((pre, cur) => {
    pre[cur.value] = cur.label;
    return pre;
}, {});
